// @ts-nocheck
import { YStack } from 'tamagui';

/**
 * The picture frame.
 *
 * A dotted mask band runs around all four sides of the page, and the content
 * sheet sits inside it — bordered, solid, enclosed. Both are in normal flow, so
 * the frame scrolls with the content rather than hovering over it: it is part of
 * the page, not furniture laid on top.
 *
 * The dots are a background field on the outer band, so the mask reads as a
 * surface the sheet is mounted on rather than as two decorative strips. The band
 * is bounded on every side — a frame, not a pair of rails running off the page.
 *
 * FRAME is the only number to change to make the border heavier or lighter.
 */
export const FRAME = 30;
const MARK_PITCH = 22; // spacing of the registration crosses

// The framed sheet is capped and centred; the mask behind it runs to the
// viewport edges. Must match Container's maxWidth or content will not sit
// square inside the frame.
export const SHEET_MAX = 1280;

export function PageFrame({ children }) {
  return (
    <>
      <style>{`
        .rd-mask {
          background-color: var(--color2);
          /* Registration marks — the alignment crosses on a drafting sheet.
             Built as an inline SVG tile rather than CSS gradients: gradients
             tile into continuous bars, which produces basketweave instead of
             discrete marks. The SVG draws one cross and repeats it, so the
             arms stay short and the field stays open.
             %23 is a literal '#' — an unescaped one ends the data URI. */
          background-image: url("data:image/svg+xml,\
%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22'%3E\
%3Cpath d='M11 9.5v3M9.5 11h3' stroke='%23c3b6a0' stroke-width='0.8' stroke-linecap='square'/%3E\
%3C/svg%3E");
          background-size: 22px 22px;
          background-position: center;
          padding: ${FRAME}px;
          min-height: 100vh;
        }
        .rd-sheet {
          background-color: var(--background);
          border: 1px solid var(--color4);
          min-height: calc(100vh - ${FRAME * 2}px);
          max-width: ${SHEET_MAX}px;
          margin-inline: auto;
        }
        /* Below this the margins are worth more as content than as frame. */
        @media (max-width: 760px) {
          .rd-mask { padding: 0; background-image: none; }
          .rd-sheet { border-left: 0; border-right: 0; min-height: 100vh; }
        }
      `}</style>

      <div className="rd-mask">
        <YStack className="rd-sheet">{children}</YStack>
      </div>
    </>
  );
}
